import coralLogo from './../logo-coral.svg'
import darkLogo from './../logo-grey.svg'
import eightbitLogo from './../logo-eightbit.svg'

const theme = {
  coral: {
    logo: coralLogo,
    homeStyle: 'home-coral.scss',
    mainStyle: 'styles-coral.scss',
    header: 'black',
    button: {
      primary: 'black',
      secondary: 'grey'
    },
    message: {
      warning: 'grey',
    },
    inverted: false,
    modal: {
      overlay: {
        //backgroundColor: 'rgba(255, 111, 97, .25)',
        backgroundColor: 'rgba(1, 1, 1, .75)',
        fontWeight: '600',
        textTransform: 'none',
        color: 'white',
        zIndex: '10',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        width: '800px',
        height: 'auto',
        background: '#FFF',
        border: '0px',
        color: 'white',
        fontSize: '16px',
      }
    }
  },
  eightbit: {
    logo: eightbitLogo,
    homeStyle: 'home-eightbit.scss',
    mainStyle: 'styles-eightbit.scss',
    header: 'black',
    button: {
      primary: 'black',
      secondary: 'grey'
    },
    message: {
      warning: 'eightbit',
    },
    inverted: false,
    modal: {
      overlay: {
        backgroundColor: 'rgba(1, 1, 3, .75)',
        fontWeight: '600',
        textTransform: 'none',
        color: 'black',
        zIndex: '10',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        width: '800px',
        height: 'auto',
        background: '#171717',
        border: '0px',
        color: 'black',
        fontSize: '16px',
      }
    }
  },
  dark: {
    logo: darkLogo,
    homeStyle: 'home-dark.scss',
    mainStyle: 'styles-dark.scss',
    header: 'black',
    button: {
      primary: 'black',
      secondary: 'grey'
    },
    message: {
      warning: 'grey',
    },
    inverted: false,
    modal: {
      overlay: {
        backgroundColor: 'rgba(1, 1, 3, .75)',
        fontWeight: '600',
        textTransform: 'none',
        color: 'black',
        zIndex: '10',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        width: '800px',
        height: 'auto',
        background: '#171717',
        border: '0px',
        color: 'black',
        fontSize: '16px',
      }
    }
  }
}

export default theme
